module.exports = __webpack_public_path__ + "img/page.eaf094cd.png";